/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqDto } from '../../models/faq-dto';

export interface FaqControllerDelete$Params {
  id: string;
}

export function faqControllerDelete(http: HttpClient, rootUrl: string, params: FaqControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
  const rb = new RequestBuilder(rootUrl, faqControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqDto>;
    })
  );
}

faqControllerDelete.PATH = '/api/faqs/{id}';
